module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "id": "dedication"
    }
  }, [_vm._v("This is for Robin Walz, Professor of History at the University of Alaska Southeast, to our mutual interest in this remarkable period of history and to our delight in its many ramifications.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("Tapestry: History’s woven moment being spun and dyed, is linked pattern to pattern to design and panorama, hiding truth until unravelled.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7f0370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-dedication.vue
// module id = 69
// module chunks = 0